import { render, staticRenderFns } from "./receive-management.vue?vue&type=template&id=369c2604&scoped=true"
import script from "./receive-management.vue?vue&type=script&lang=js"
export * from "./receive-management.vue?vue&type=script&lang=js"
import style0 from "./receive-management.vue?vue&type=style&index=0&id=369c2604&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369c2604",
  null
  
)

export default component.exports